import React, { useEffect, useState } from 'react';
import { Box, Text, FormControl, FormLabel, Input, Select, Button, SimpleGrid, Divider } from '@chakra-ui/react';
import { useCommitteeContext } from '../context/CommitteeContext';
import { committeeMembers } from '../components/CommitteeSidebar';
const TEAL = '#00897B';
const BORDER_COLOR = '#006666';
const positions = ['President', 'Vice President', 'Pos 1', 'Pos 2', 'Pos 3', 'Pos 4', 'Pos 5'];
const terms = ['1st', '2nd', '3rd'];
function parseName(fullName: string): {
  firstName: string;
  lastName: string;
} {
  if (!fullName || fullName === 'Vacant') return {
    firstName: '',
    lastName: ''
  };
  const parts = fullName.trim().split(' ');
  const firstName = parts[0] || '';
  const lastName = parts.slice(1).join(' ') || '';
  return {
    firstName,
    lastName
  };
}
const inputStyles = {
  borderColor: 'gray.300',
  focusBorderColor: TEAL,
  _hover: {
    borderColor: TEAL
  },
  size: 'sm' as const,
  bg: 'white'
};
const labelStyles = {
  fontSize: 'xs' as const,
  fontWeight: '600' as const,
  color: TEAL,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.05em',
  mb: 0.5
};
export function CommitteePage() {
  const {
    selectedIndex
  } = useCommitteeContext();
  const selected = committeeMembers[selectedIndex];
  const {
    firstName: initFirst,
    lastName: initLast
  } = parseName(selected.name);
  const [firstName, setFirstName] = useState(initFirst);
  const [lastName, setLastName] = useState(initLast);
  const [company, setCompany] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [position, setPosition] = useState(positions[0]);
  const [term, setTerm] = useState(terms[0]);
  const [startDate, setStartDate] = useState('');
  const [termEndDate, setTermEndDate] = useState('');
  useEffect(() => {
    const {
      firstName: f,
      lastName: l
    } = parseName(committeeMembers[selectedIndex].name);
    setFirstName(f);
    setLastName(l);
    setCompany('');
    setPhone('');
    setEmail('');
    setStreet('');
    setCity('');
    setState('');
    setZip('');
    setPosition(positions[0]);
    setTerm(terms[0]);
    setStartDate('');
    setTermEndDate('');
  }, [selectedIndex]);
  const handleSave = () => {
    console.log('Saving committee member...');
  };
  return <Box px={6} py={3} maxW="700px" data-id="element-238">
      <Text fontSize="xl" fontWeight="bold" color="black" mb={3} data-id="element-239">
        Edit Committee Member
      </Text>

      <Box border={`2px solid ${BORDER_COLOR}`} borderRadius="md" bg="white" p={4} data-id="element-240">
        {/* Name row */}
        <SimpleGrid columns={2} spacing={3} mb={3} data-id="element-241">
          <FormControl data-id="element-242">
            <FormLabel {...labelStyles} data-id="element-243">First Name</FormLabel>
            <Input {...inputStyles} value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="First Name" data-id="element-244" />
          </FormControl>
          <FormControl data-id="element-245">
            <FormLabel {...labelStyles} data-id="element-246">Last Name</FormLabel>
            <Input {...inputStyles} value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Last Name" data-id="element-247" />
          </FormControl>
        </SimpleGrid>

        <FormControl mb={3} data-id="element-248">
          <FormLabel {...labelStyles} data-id="element-249">Company Name</FormLabel>
          <Input {...inputStyles} value={company} onChange={e => setCompany(e.target.value)} placeholder="Company Name" data-id="element-250" />
        </FormControl>

        {/* Address block */}
        <FormControl mb={3} data-id="element-251">
          <FormLabel {...labelStyles} data-id="element-252">Street Address</FormLabel>
          <Input {...inputStyles} value={street} onChange={e => setStreet(e.target.value)} placeholder="Street Address" data-id="element-253" />
        </FormControl>

        <SimpleGrid columns={3} spacing={3} mb={3} data-id="element-254">
          <FormControl data-id="element-255">
            <FormLabel {...labelStyles} data-id="element-256">City</FormLabel>
            <Input {...inputStyles} value={city} onChange={e => setCity(e.target.value)} placeholder="City" data-id="element-257" />
          </FormControl>
          <FormControl data-id="element-258">
            <FormLabel {...labelStyles} data-id="element-259">State</FormLabel>
            <Input {...inputStyles} value={state} onChange={e => setState(e.target.value)} placeholder="State" maxLength={2} data-id="element-260" />
          </FormControl>
          <FormControl data-id="element-261">
            <FormLabel {...labelStyles} data-id="element-262">Zip</FormLabel>
            <Input {...inputStyles} value={zip} onChange={e => setZip(e.target.value)} placeholder="Zip" data-id="element-263" />
          </FormControl>
        </SimpleGrid>

        {/* Phone + Email */}
        <SimpleGrid columns={2} spacing={3} mb={3} data-id="element-264">
          <FormControl data-id="element-265">
            <FormLabel {...labelStyles} data-id="element-266">Phone</FormLabel>
            <Input {...inputStyles} value={phone} onChange={e => setPhone(e.target.value)} placeholder="Phone" type="tel" data-id="element-267" />
          </FormControl>
          <FormControl data-id="element-268">
            <FormLabel {...labelStyles} data-id="element-269">Email</FormLabel>
            <Input {...inputStyles} value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" data-id="element-270" />
          </FormControl>
        </SimpleGrid>

        <Divider borderColor="gray.200" my={3} data-id="element-271" />

        {/* Role Info */}
        <SimpleGrid columns={2} spacing={3} mb={3} data-id="element-272">
          <FormControl data-id="element-273">
            <FormLabel {...labelStyles} data-id="element-274">Position</FormLabel>
            <Select value={position} onChange={e => setPosition(e.target.value)} borderColor="gray.300" focusBorderColor={TEAL} _hover={{
            borderColor: TEAL
          }} size="sm" bg="white" data-id="element-275">
              {positions.map(p => <option key={p} value={p} data-id="element-276">
                  {p}
                </option>)}
            </Select>
          </FormControl>
          <FormControl data-id="element-277">
            <FormLabel {...labelStyles} data-id="element-278">Term</FormLabel>
            <Select value={term} onChange={e => setTerm(e.target.value)} borderColor="gray.300" focusBorderColor={TEAL} _hover={{
            borderColor: TEAL
          }} size="sm" bg="white" data-id="element-279">
              {terms.map(t => <option key={t} value={t} data-id="element-280">
                  {t}
                </option>)}
            </Select>
          </FormControl>
        </SimpleGrid>

        <SimpleGrid columns={2} spacing={3} mb={4} data-id="element-281">
          <FormControl data-id="element-282">
            <FormLabel {...labelStyles} data-id="element-283">Start Date</FormLabel>
            <Input {...inputStyles} value={startDate} onChange={e => setStartDate(e.target.value)} type="date" data-id="element-284" />
          </FormControl>
          <FormControl data-id="element-285">
            <FormLabel {...labelStyles} data-id="element-286">Term End Date</FormLabel>
            <Input {...inputStyles} value={termEndDate} onChange={e => setTermEndDate(e.target.value)} type="date" data-id="element-287" />
          </FormControl>
        </SimpleGrid>

        <Button bg="#0d6dfc" color="white" px={8} size="sm" borderRadius="md" fontWeight="semibold" _hover={{
        bg: '#0b5fd9'
      }} _active={{
        bg: '#0a52be'
      }} onClick={handleSave} data-id="element-288">
          Save
        </Button>
      </Box>
    </Box>;
}